<template>
    <section class="col s12">
        <div class="row">
            <div class="input-field col s6">
                <input type="text" id="edital" name="edital" :value="edital.ano" disabled>
                <label for="edital">Edital</label>
            </div>

            <div class="input-field col s6">
                <input type="text" id="acao" name="acao" :value="acao.titulo" disabled>
                <label for="acao">Ação</label>
            </div>

            <div class="input-field col s6">
                <input type="text" id="coordenador" name="coordenador" :value="coordenador.name" disabled>
                <label for="coordenador">Coordenador</label>
            </div>

            <div class="input-field col s6">
                <input type="text" id="modalidade" name="modalidade" :value="acao.modalidade" disabled>
                <label for="modalidade">Modalidade</label>
            </div>

            <div class="input-field col s6">
                <input type="text" id="centro" name="centro" :value="acao.centro" disabled>
                <label for="centro">Centro</label>
            </div>

            <div class="input-field col s6">
                <input type="text" id="unidade" name="unidade" :value="acao.unidade" disabled>
                <label for="unidade">Unidade</label>
            </div>

            <div class="col s12">
                <p>
                    <strong>O total de bolsas solicitadas foi de:</strong>&nbsp;<span>{{ quantidadeDeCotasSolicitadas }} bolsa(s)</span>
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "dados_inscricao",
    props: {
        edital: {
            type: Object,
            default: () => { return null }
        },

        acao: {
            type: Object,
            default: () => { return null }
        },

        coordenador: {
            type: Object,
            default: () => { return null }
        },

        quantidadeDeCotasSolicitadas: {
            type: Number,
            default: 0
        },
    },
}
</script>

<style scoped>

</style>
